function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "prefix__iconfinder_bar_chart_172571",
    width: 16,
    height: 21.107,
    viewBox: "0 0 16 21.107"
  }, props), _ref, React.createElement("path", {
    id: "prefix__Rectangle_10",
    d: "M0 0H3.84V13.037H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 10",
    transform: "translate(.96 7.57)",
    style: {
      "fill": "none",
      "stroke": "#20c9d2",
      "strokeLinecap": "round",
      "strokeMiterlimit": 10
    }
  }), React.createElement("path", {
    id: "prefix__Rectangle_11",
    d: "M0 0H3.84V8.411H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 11",
    transform: "translate(6.08 12.196)",
    style: {
      "fill": "none",
      "stroke": "#20c9d2",
      "strokeLinecap": "round",
      "strokeMiterlimit": 10
    }
  }), React.createElement("path", {
    id: "prefix__Rectangle_12",
    d: "M0 0H3.84V18.505H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 12",
    transform: "translate(11.2 2.103)",
    style: {
      "fill": "none",
      "stroke": "#20c9d2",
      "strokeLinecap": "round",
      "strokeMiterlimit": 10
    }
  }), React.createElement("path", {
    id: "prefix__Rectangle_13",
    d: "M0 0H16V21.028H0z",
    "data-name": "Rectangle 13",
    style: {
      "fill": "none"
    }
  }));
};

export default __webpack_public_path__ + "static/media/job_property_condition.1d5dd528.svg";
export { SvgComponent as ReactComponent };